// Wait for the DOM to be fully loaded before executing the script
document.addEventListener('DOMContentLoaded', function() {
    // Select all elements with the class 'collection-header-link-blocks'
    var quickLinks = document.querySelectorAll('.collection-header-link-blocks');
    
    // Select all Flickity slider elements within the quick links
    var quickLinksSlider = document.querySelectorAll('.collection-header-link-blocks .flickity-viewport .flickity-slider');
    
    // Check if the first slider has no child elements
    if (quickLinksSlider[0].children.length <= 0) {
        // If the slider is empty, remove the entire quick links section
        quickLinks[0].remove();
    }
});
